function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import isEqual from 'lodash.isequal';
import omit from 'lodash.omit';
import { useTranslation } from 'react-i18next';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import HalfYearDropdown from '../HalfYearDropdown';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
const StaffCostsTableData = _ref => {
  let {
    isSaved,
    setIsSaved,
    notSavedStyle,
    body,
    setBody,
    saveData,
    rowData,
    deleteData,
    data,
    removeEmptyRow,
    emptyRowId,
    showHalfYearColumn,
    elsterYearForStaffCost
  } = _ref;
  const {
    t
  } = useTranslation();
  const changeBody = e => {
    const key = e.target.name;
    const value = e.target.value;
    if (key === 'year') {
      saveData(_objectSpread(_objectSpread({}, body), {}, {
        [key]: value
      }));
    }
    setBody(_objectSpread(_objectSpread({}, body), {}, {
      [key]: value
    }));
  };
  const changeDate = (name, date) => {
    const updatedBody = _objectSpread(_objectSpread({}, body), {}, {
      [name]: date
    });
    setBody(updatedBody);
    saveData(updatedBody);
  };
  const saveOnBlur = () => {
    saveData(body);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    style: isSaved ? {} : notSavedStyle
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: body.employee_name_number,
    onBlur: saveOnBlur,
    name: "employee_name_number",
    onChange: changeBody,
    size: "md",
    type: "text"
  })), showHalfYearColumn && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(HalfYearDropdown, {
    elsterYear: elsterYearForStaffCost,
    value: body.year,
    onChange: val => changeBody({
      target: {
        name: 'year',
        value: val
      }
    }),
    dataTestId: "staff_costs_year"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "sum_working_hr_rd",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: body.fulltime
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "rel_agreed_annual_working_hrs",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: body.fulltime
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(DatePicker, {
    selected: body.project_join_employee,
    onChange: date => changeDate('project_join_employee', date),
    disabled: !body.fulltime,
    "data-testid": "project_join_employee"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(DatePicker, {
    selected: body.project_exit_employee,
    onChange: date => changeDate('project_exit_employee', date),
    disabled: !body.fulltime,
    "data-testid": "project_exit_employee"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    object: rowData.calculations,
    name: "share_of_working_time",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "a1_exec_special_payment",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "a2_sum_special_payments",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "sum_of_a1_a2",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    onBlur: saveOnBlur,
    object: body,
    name: "employers_social_security",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "gross_wage",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "b_excluding_special_payments",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      marginRight: '8px'
    },
    onClick: () => emptyRowId !== null ? removeEmptyRow(emptyRowId) : deleteData(body, data),
    "data-testid": "delete_button"
  }))));
};
export default StaffCostsTableData;